import { Box, FormControlLabel, Switch, Typography, styled } from "@mui/material";
import { BasicTableRowStyles } from "../../components/common/Common.styles";
import { theme } from "../../theme";

export const EmployeesWrapper = styled(Box)(({ theme }) => ({
  height: "auto",
  backgroundColor: theme.palette.backgroundColor.main,
}));

export const EmployeesEditRowStyles = styled(BasicTableRowStyles)(
  ({ theme }) => ({
    "&:last-child": {
      border: "none",
    },
    "& > div": {
      width: "100%",
      boxSizing: "border-box",
      "&:first-child": {
        paddingLeft: "35px",
        [theme.breakpoints.down(1700)]: {
          "&": {
            padding: "0 0 0 25px!important",
          },
        },
      },
    },
    fieldset: {
      border: "none",
    },
    input: {
      borderRadius: "5px",
    },
  })
);

export const InvitationCodeStyles = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%"
}));

export const EmployeesBtnsCell = styled(Box)(
  ({
    display: "flex",
    width: "100%",
    paddingRight: "35px!important",
    boxSizing: "border-box",
    justifyContent: "flex-end!important",
    [theme.breakpoints.down(1700)]: {
      "&": {
        padding: "0 25px 0 0!important",
      },
    },
  }));

export const SearchBarButtonContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  height: "100%",
  alignItems: "center",
  gap: "1rem",
  justifyContent: "end",
})

export const TableSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.contrastText),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export const TemplateDownloadBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  maxWidth: "fit-content",
  padding: "0.5rem 1rem",
  borderRadius: "5px",
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  marginLeft: "auto",
  marginRight: "0",

  "& svg": {
    fontSize: "1.75rem",
    color: theme.palette.primary.main,
  },

  "& a": {
    fontSize: "1rem",
    fontWeight: "500",
    textDecoration: "none",
    color: theme.palette.text.primary,
    transition: "color 0.2s ease-in-out",
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  },
}));

export const GroupNamesContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(0.5),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
}));

export const GroupNameChip = styled("span")(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.text.primary,
  borderRadius: theme.spacing(1),
  padding: `${theme.spacing(0.3)} ${theme.spacing(1)}`,
  fontSize: "0.75rem",
  maxWidth: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const ModulesDialogWrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  gap: theme.spacing(3)
}));

export const ModulesTitle = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontWeight: 600,
  fontSize: "1.5rem",
}));

export const ModuleSectionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  overflowY: "auto",
  flex: "1 1 auto",
  gap: theme.spacing(1),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const ModuleCategoryCard = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const ModuleCategoryTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1.1rem",
  marginBottom: theme.spacing(1),
}));

export const ModuleList = styled(Box)(({ theme }) => ({
  listStyle: "none",
  padding: 0,
  margin: 0,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  height: "100%",
}));

export const CheckboxListTile = styled(FormControlLabel)(({ theme }) => ({
  ":hover": {
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
  }
}));

export const AssignedText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: "0.85rem",
  color: theme.palette.text.secondary,
}));

export const DialogActionsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
}));

export const CreateDialogGridContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const CreateDialogFullWidthBox = styled(Box)(({ theme }) => ({
  gridColumn: "1 / -1",
  marginTop: theme.spacing(1),
}));